export default class AuthResponse {
    // #region Properties
    isSucceded = false;
    errorCode = "";
    errorMessage = "";
    customData = {};
    token;
    // #endregion
    // #region Constructor
    constructor(init) {
        Object.assign(this, init);
    }
}
